// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Modal from '../../../modal';
import ButtonBar from '../../../buttonBar';
import Button from '../../../button';
import {
  getIsShowingModal,
  getModalType,
  getModalTitle,
  getModalDescription,
  getModalAcceptButtonText,
  getModalDeclineButtonText,
} from '../../../../store/configuration/vbmr/selectors';
import type { VbmrModalType } from '../../../../store/configuration/vbmr/types';
import {
  acceptVbmr,
  declineVbmr,
} from '../../../../store/configuration/vbmr/actions';
import type { Theme } from '../../../../types';

const Text = styled<any, Theme>('p')`
  margin-bottom: 2rem;
`;

type StateProps = {|
  modalTitle: string,
  modalDescription: string,
  modalAcceptButtonText: string,
  modalDeclineButtonText: string,
  isShowingModal: boolean,
  modalType: ?VbmrModalType, // eslint-disable-line react/no-unused-prop-types
|};

type DispatchProps = {|
  acceptVbmrHandler: Function,
  declineVbmrHandler: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

const VbmrModal = ({
  isShowingModal,
  declineVbmrHandler,
  acceptVbmrHandler,
  modalTitle,
  modalDescription,
  modalDeclineButtonText,
  modalAcceptButtonText,
}: Props) => (isShowingModal ? (
  <Modal
    isOpen
    onClose={declineVbmrHandler}
    closeOnOverlayClick={false}
    ariaLabel="label"
    title={modalTitle}
    size="large"
  >
    <Text>{modalDescription}</Text>
    <ButtonBar>
      <Button onClick={declineVbmrHandler} variant="ghost">{modalDeclineButtonText}</Button>
      <Button onClick={acceptVbmrHandler}>{modalAcceptButtonText}</Button>
    </ButtonBar>
  </Modal>
) : null);

const mapStateToProps = (state: any): StateProps => ({
  modalTitle: getModalTitle(state),
  modalDescription: getModalDescription(state),
  modalAcceptButtonText: getModalAcceptButtonText(state),
  modalDeclineButtonText: getModalDeclineButtonText(state),
  isShowingModal: getIsShowingModal(state),
  modalType: getModalType(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  acceptVbmrHandler: () => dispatch(acceptVbmr()),
  declineVbmrHandler: () => dispatch(declineVbmr()),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(VbmrModal);
